import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { UpdatePurchaseOrderParams, PurchaseOrderUpdateType } from "../types/UpdatePurchaseOrderParams";
import { UpdatePurchaseOrderResult } from "../types/UpdatePurchaseOrderResult";


export const useUpdatePurchaseOrder = (
	params: UpdatePurchaseOrderParams,
	onSuccess: (result: UpdatePurchaseOrderResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	switch (params.updateType) {
		case PurchaseOrderUpdateType.Validate:
			method = 'validate';
			requestParams = {
				purchaseOrderID: params.purchaseOrderID,
				validatedShipDate: params.validatedShipDate
			};
			break;
		case PurchaseOrderUpdateType.Ship:
			method = 'ship';
			requestParams = {
				purchaseOrderID: params.purchaseOrderID,
				GS1128: params.GS1128,
				products: params.products
			};
			break;
		case PurchaseOrderUpdateType.ValidateDelivery:
			method = 'validate-delivery';
			requestParams = {
				purchaseOrderID: params.purchaseOrderID,
				validatedDeliveryDate: params.validatedDeliveryDate
			};
			break;
		case PurchaseOrderUpdateType.SubmitDelivery:
			method = 'submit-delivery';
			requestParams = {
				purchaseOrderID: params.purchaseOrderID,
				GS1128: params.GS1128,
				products: params.products
			};
			break;
		case PurchaseOrderUpdateType.Service:
			method = 'service';
			requestParams = {
				purchaseOrderID: params.purchaseOrderID,
				serviceInitiatedDate: params.serviceInitiatedDate
			};
			break;
	}

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("purchase-order/" + method, requestParams) as UpdatePurchaseOrderResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when updating the purchase order: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
